import React, { useContext } from 'react';

import { type ILayout } from './LayoutProvider';

const layoutDefault: ILayout = {
  layout: {
    authenticationBar: undefined,
    headerBar: undefined,
    accessibilityBar: undefined,
    navigationBar: undefined,
    isNavigationLoading: true,
    pageFooterBar: undefined,
    pageCorporateLogosBlock: undefined,
    isGrayScaled: false,
    setIsGrayScaled: undefined,
    isHightContrast: false,
    setIsHightContrast: undefined,
  },
};

const LayoutContext = React.createContext<ILayout>(layoutDefault);

const useLayoutContext = () => useContext(LayoutContext);

export { useLayoutContext };

export default LayoutContext;
